import { render, staticRenderFns } from "./stock-mapping-product.vue?vue&type=template&id=062791c6&scoped=true"
import script from "./stock-mapping-product.vue?vue&type=script&lang=ts"
export * from "./stock-mapping-product.vue?vue&type=script&lang=ts"
import style0 from "./stock-mapping-product.vue?vue&type=style&index=0&id=062791c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062791c6",
  null
  
)

export default component.exports